module.exports = __webpack_public_path__ + "static/media/1_A1_16.16e4c0b2.png";